import { Calendar, CalendarTime, Clock, LocationMarker } from "@repo/icons";
import {
  formatDateAndTimeIgnoringTimezone,
  formatIgnoringTimezone,
} from "@repo/lib/src/helpers";
import { CpsLinedData } from "corpus";
import { parseISO } from "date-fns";

interface AppointmentDrawerPatientLinksProps {
  appointmentTypeName: string;
  startTime: string;
  endTime: string;
  date: string;
  unit: string;
}

export const AppointmentDrawerScheduleInformation = ({
  appointmentTypeName,
  startTime,
  endTime,
  date,
  unit,
}: AppointmentDrawerPatientLinksProps): JSX.Element => {
  const formattedStartTime = formatDateAndTimeIgnoringTimezone(date, startTime, "HH:mm");

  const formattedEndTime = formatDateAndTimeIgnoringTimezone(date, endTime, "HH:mm");

  const formattedDate = formatIgnoringTimezone(parseISO(date), "dd 'de' MMMM");

  return (
    <div className="my-4 flex flex-col items-start gap-3">
      <CpsLinedData Icon={Calendar}>{appointmentTypeName}</CpsLinedData>
      <CpsLinedData Icon={Clock}>
        {formattedStartTime} - {formattedEndTime}
      </CpsLinedData>
      <CpsLinedData Icon={CalendarTime}>{formattedDate}</CpsLinedData>
      <CpsLinedData Icon={LocationMarker}>{unit}</CpsLinedData>
    </div>
  );
};
